export enum XpoRowModelType {
  ClientSide = 'client-side',
  Infinite = 'infinite',
}
